export default __webpack_public_path__ + "static/media/kitchen3-afterK-2048w.749c0d01.webp";